export function getUserDisplayName(user, fallback = '') {
  if (!user) {
    return fallback;
  }

  return (
    user.data?.name ||
    user.data?.username ||
    user.name ||
    user.username ||
    fallback
  );
}

export function getLoginQualificationEnumName(value) {
  const enums = ['第一款', '第二款', '第三款', '第四款', '第五款'];
  const enumNames = [
    '具有符合教育部採認規定之大專院校以上法律學位。',
    '曾於符合教育部採認規定之大專院校修習專利民事訴訟業務相關法律科目，例如智慧財產案件審理法、民事訴訟法等科目至少三學分，取得學分證明。',
    '申請前三年內曾參加本會、政府機關（構）、學校及團體所舉辦專利法、智慧財產案件審理法、民事訴訟法等與專利訴訟業務相關之研習、訓練、課程或會議，達三十小時以上。',
    '申請前三年內曾為中央或地方機關所屬專任人員，辦理專利法制、審查（審議）、訴願或訴訟相關業務，合計達一年以上。',
    '曾經審判長許可擔任本要點第二條專利民事訴訟案件之訴訟代理人，案件量達五件以上。',
  ];

  const index = enums.findIndex((it) => it === value);
  return index > -1 ? enumNames[index] : value;
}
